import CatalogContainer from '../src/containers/Catalog';

export default CatalogContainer;
